import * as React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const Seo = ({ title, description, url, image, lang, meta }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            defaultTitle: title
            defaultDescription: description
            siteUrl
            defaultImage: image
          }
        }
      }
    `
  )

  const { defaultTitle, defaultDescription, siteUrl, defaultImage } = site.siteMetadata

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${'https://make.dmm.com'}${image || defaultImage}`,
    url: `${url || siteUrl}`
  }

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={seo.title}
      titleTemplate={seo.title ? `%s - ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: seo.description
        },
        {
          property: `fb:app_id`,
          content: `301754529958853`
        },
        {
          property: `og:locale`,
          content: `ja_JP`
        },
        {
          property: `og:url`,
          content: seo.url
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          property: `og:title`,
          content: seo.title
        },
        {
          property: `og:description`,
          content: seo.description
        },
        {
          property: `og:image`,
          content: seo.image
        },
        {
          property: `og:site_name`,
          content: `DMM.make`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:site`,
          content: `@DMM_make`
        }
      ].concat(meta)}
    >
      <link rel="canonical" href="https://make.dmm.com/" />
      <link rel="shortcut icon" href="https://www.dmm.com/images/common/pinned/general/favicon.ico" />
      <link href="https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,500,700,900&display=swap" rel="stylesheet" />
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `ja`,
  meta: [],
  description: ``
}

Seo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object)
}

export default Seo
